<div class="m-portlet">
	<div class="m-portlet__head">
		<div class="m-portlet__head-progress">
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="m-portlet__head-caption">
			<div class="m-portlet__head-title">
				<span class="m-portlet__head-icon m--hide">
					<i class="la la-gear"></i>
				</span>
				<h3 class="m-portlet__head-text">
					{{data.title}}
				</h3>
			</div>
		</div>
	</div>
	<div class="m-form">
		<div class="m-portlet__body">
			<div class="form-group m-form__group row">
				<div class="col-lg-12">
					<div [innerHtml]="viewLoading ? data.waitDesciption : data.description"></div>
				</div>
			</div>
			<hr>
			<div class="form-group m-form__group row" style="padding-top: 5px; padding-bottom: 5px;">
				<div class="col-lg-12">
					<small><b>Basit Rapor:</b> Raporda sadece belge başlık detayları gösterilir.</small><br />
					<small><b>Detaylı Rapor:</b> Raporda başlık bilgileriyle beraber ürün/hizmet satırlarıda gösterilir.</small> 
				</div>
			</div>
			<div class="form-group m-form__group row" style="padding-top: 5px; padding-bottom: 5px;">
				<div class="col-lg-12">
					<small><b>Basit Rapor Dövizli:</b> Raporda sadece belge başlık detayları gösterilir.</small><br />
					<small><b>Detaylı Rapor Dövizli:</b> Raporda başlık bilgileriyle beraber ürün/hizmet satırlarıda gösterilir.</small> 
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
			<div class="m-form__actions m-form__actions--sm">
				<button  mat-raised-button (click)="onYesClick()" color="primary" cdkFocusInitial
					[disabled]="viewLoading">{{ data.button1}}</button> &nbsp;
				<button  mat-raised-button color="warn" (click)="onNoClick()">{{ data.button2}}</button>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
			<div class="m-form__actions m-form__actions--sm">
				<button  mat-raised-button color="primary" (click)="onYesDovizliClick()">{{ data.button3}}</button>
				 &nbsp;
				<button  mat-raised-button color="warn" (click)="onNoDovizliClick()">{{ data.button4}}</button>
			</div>
		</div>
	</div>
</div>